module.exports = __webpack_public_path__ + "img/Date_companie.2e86c7ff.png";